<template>
  <div>
   <!-- <div class="searchBox">
    <div class="searchLeft">
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
    </div>
   </div> -->
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="incomeDate"
      label="分币日期">
    </el-table-column>
    <!-- <el-table-column
      prop="network_storage_power"
      label="矿池名称">
    </el-table-column> -->
    <el-table-column
      prop="coinStart"
      label="0点累计出块奖励">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.coinStart,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="coinEnd"
      label="24点累计出块奖励">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.coinEnd,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="coinIncome"
      label="本次FIL分配数">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.coinIncome,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="maxPower"
      label="矿池算力数(TiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.maxPower,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="unitIncome"
      label="单TiB平均收益">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.unitIncome,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="gas"
      label="Gas">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.gas,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="burn"
      label="惩罚值">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.burn,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="burn"
      label="状态">
      <template slot-scope="scope">
        <span>{{scope.row.status==1?'未分币':scope.row.status==2?'分币中':'已完成'}}</span>
      </template>
    </el-table-column>
    <el-table-column
        fixed="right"
        width="180px"
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openCent(scope.row.id)" v-if="scope.row.status==1"><i class="el-icon-view" style="margin-right:3px;"></i>开始分币</el-button>
          <el-button size="mini" type="info" disabled v-if="scope.row.status==2">分币中</el-button>
          <el-button size="mini" type="primary" @click="eidtCent(scope.row)" v-if="scope.row.status==1"><i class="el-icon-view"></i>编辑</el-button>
        </template>
      </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <!-- <el-dialog
      :title="ruleForm.id?'编辑':'新增'"
      :visible.sync="dialogVisible"
      width="440px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="矿池名称" prop="name">
              <el-input placeholder="请输入矿池名称" v-model="ruleForm.name" style="width:240px"></el-input>
          </el-form-item>
          <el-form-item label="节点" prop="isDel">
            <el-select v-model="ruleForm.nodeNumbers" multiple placeholder="请选择" style="width:240px">
              <el-option
                v-for="item in dataArr"
                :key="item.key"
                :label="item.label"
                :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      title="编辑分币"
      :visible.sync="dialogVisible"
      width="1200px">
        <div class="data_box">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
            <div class="samll_title" v-for="(item,index) in ruleForm.params" :key="index">
              <el-col :span="4">
                <el-form-item label="节点名称">
                  <el-input v-model.trim="item.nodeNumber" disabled ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="分币值" :prop="'params.'+index+'.coinIncome'" :rules="rules.coinIncome">
                  <el-input type="number" v-model.trim="item.coinIncome"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="算力数" :prop="'params.'+index+'.maxPower'" :rules="rules.maxPower">
                  <el-input type="number" v-model.trim="item.maxPower"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="Gas" :prop="'params.'+index+'.gas'" :rules="rules.gas">
                  <el-input type="number" v-model.trim="item.gas"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="惩罚值" :prop="'params.'+index+'.burn'" :rules="rules.burn">
                  <el-input type="number" v-model.trim="item.burn"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <el-form-item label="备注">
              <el-input type="text" v-model.trim="ruleForm.memo"></el-input>
            </el-form-item>
            <div class="foot_box">
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
              </span>
            </div>
          </el-form>
        </div>
      
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        poolId: null
      },
      tableData: [],
      dialogVisible: false,
      ruleForm:{
        memo: '',
        poolIncomeId:'',
        params: [],
      },
      params:{
        coinIncome: null,
        maxPower: null,
        gas: null,
        burn: null,
      },
      rules: {
        coinIncome: [
          { required: true, message: '请输入分币值', trigger: 'blur' },
        ],
        maxPower: [
          { required: true, message: '请输入算力值', trigger: 'blur' },
        ],
        gas: [
          { required: true, message: '请输入Gas值', trigger: 'blur' },
        ],
        burn: [
          { required: true, message: '请输入惩罚值', trigger: 'blur' },
        ],
      }
    };
  },
  created() {
    if (this.$route.query.id) {
      this.searchForm.poolId=this.$route.query.id
      this.getTableList();
    }
  },
  methods: {
    submitForm(formName) {
      let _this = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let list = JSON.stringify(_this.ruleForm.params)
          let data = {
            memo: _this.ruleForm.memo,
            poolIncomeId: _this.ruleForm.poolIncomeId,
            params: list
          }
          let res = await _this.$http.updateNodeIncome({...data});
          if (res) {
            _this.$message.success('操作成功！');
            _this.dialogVisible=false;
            _this.ruleForm.poolIncomeId = null
            _this.ruleForm.params = []
            _this.getTableList()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async eidtCent(item) {
      let res = await this.$http.nodeIncomeDetails({poolIncomeId:item.id});
      if (res) {
        this.ruleForm.params = res.data
        this.ruleForm.poolIncomeId = item.id
        this.ruleForm.memo = item.memo
        this.dialogVisible = true
      }  
    },
    // 开始分币
    openCent(id) {
      this.$confirm('此操作将进行分币, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await this.$http.nodePoolAllocate({poolIncomeId:id});
        if(res) {
          this.getTableList();
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });          
      });
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
      let res = await this.$http.nodePoolIncomeRecords({...this.searchForm});
      if (res) {
        this.tableData=res.data.list
        this.totalNum=Number(res.data.totalSize)
      }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
.data_box{
  min-height: 300px;
  max-height: 500px;
  overflow-y: auto;
}
.samll_title{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.foot_box{
  text-align: right;
}
</style>
<style>
.data_box .el-input__inner{
  padding: 0 5px;
}
</style>
